"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.evaluateVolume = void 0;

var evaluateVolume = function evaluateVolume(_ref) {
  var frame = _ref.frame,
      volume = _ref.volume,
      _ref$mediaVolume = _ref.mediaVolume,
      mediaVolume = _ref$mediaVolume === void 0 ? 1 : _ref$mediaVolume;

  if (typeof volume === 'number') {
    return Math.min(1, volume * mediaVolume);
  }

  if (typeof volume === 'undefined') {
    return Number(mediaVolume);
  }

  var evaluated = volume(frame) * mediaVolume;

  if (typeof evaluated !== 'number') {
    throw new TypeError("You passed in a a function to the volume prop but it did not return a number but a value of type ".concat(typeof evaluated, " for frame ").concat(frame));
  }

  if (Number.isNaN(evaluated)) {
    throw new TypeError("You passed in a function to the volume prop but it returned NaN for frame ".concat(frame, "."));
  }

  if (!Number.isFinite(evaluated)) {
    throw new TypeError("You passed in a function to the volume prop but it returned a non-finite number for frame ".concat(frame, "."));
  }

  return Math.max(0, Math.min(1, evaluated));
};

exports.evaluateVolume = evaluateVolume;